export default __webpack_public_path__ + "static/media/Aptos-Mono.dbd15293.ttf";